/** @format */

import { Row, Col, Container } from "react-bootstrap";
import style from "./index.module.scss";
import close_btn from "../../assets/images/btn_close_popup.png";
import Login from "./Login";
import Signup from "./Signup";
import MochiImage_modal from "../common/modal/MochiImage_modal";
import ButtonMethod from "../common/button/ButtonMethod";
import facebook from "../../assets/images/facebook.png";
import google from "../../assets/images/google.png";
import ButtonCircle from "../common/button/ButtonCircle";
import btn_back from "../../assets/images/btn_back.png";
import { useEffect, useRef } from "react";
import { createCookieThatLastsForADay } from "../../untils/helpers";
import AccountOperations from "../services/AccountOperations";

import { auth, providerGoogle, OAuthProvider } from "../../firebase-config";
import { signInWithPopup } from "firebase/auth";

const PopupLoginSignup = ({
    pageLoginSignup,
    setPageLoginSignup,
    setIsLogin,
}) => {
    const handleBack = () => {
        setPageLoginSignup((prev) => {
            prev.shift();

            return [...prev];
        });
    };

    return (
        <Container className={style.container} fluid={true}>
            <Row>
                <Col className={"col-lg-6 " + style.wrap}>
                    <Row className={style.wrap_closeBtnHeader}>
                        {pageLoginSignup[0] !== "signup" ? (
                            <img
                                onClick={() => {
                                    setPageLoginSignup([]);
                                }}
                                src={close_btn}
                                alt="close btn"
                            />
                        ) : (
                            <img
                                onClick={handleBack}
                                src={btn_back}
                                alt="close btn"
                            />
                        )}
                    </Row>
                    {pageLoginSignup[0] === null && (
                        <FirstScreen
                            setPageLoginSignup={setPageLoginSignup}
                            setIsLogin={setIsLogin}
                        />
                    )}
                    {pageLoginSignup[0] === "login" && (
                        <Login
                            setIsLogin={setIsLogin}
                            setPageLoginSignup={setPageLoginSignup}
                        />
                    )}
                    {pageLoginSignup[0] === "signup" && (
                        <Signup
                            setIsLogin={setIsLogin}
                            setPageLoginSignup={setPageLoginSignup}
                        />
                    )}
                    <div className={style.footer_options}>
                        {pageLoginSignup[0] === null ||
                        pageLoginSignup[0] === "signup" ? (
                            <p>
                                Bạn đã có tài khoản?{" "}
                                <span
                                    onClick={() => {
                                        setPageLoginSignup((prev) => [
                                            "login",
                                            ...prev,
                                        ]);
                                        // setIsOpenPopupLoginSignup((prev) => {
                                        //     return { ...prev, type: "login" };
                                        // });
                                    }}>
                                    Đăng nhập ngay
                                </span>
                            </p>
                        ) : (
                            <p>
                                Chưa có tài khoản?{" "}
                                <span
                                    onClick={() => {
                                        setPageLoginSignup((prev) => [
                                            null,
                                            ...prev,
                                        ]);
                                        // setIsOpenPopupLoginSignup((prev) => {
                                        //     return { ...prev, type: "signup" };
                                        // });
                                    }}>
                                    Tạo tài khoản học mới
                                </span>
                            </p>
                        )}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

const FirstScreen = ({ setPageLoginSignup, setIsLogin }) => {
    const handleLoginGoogle = async () => {
        try {
            let result = await signInWithPopup(auth, providerGoogle);

            const credential = OAuthProvider.credentialFromResult(result);
            const googleToken = credential.accessToken;
            const googleId = credential.idToken;
            // The signed-in user info.
            const user = result.user;
            const data = new FormData();
            data.append("email", user.email);
            data.append("name", user.displayName);
            data.append("oauth", "google");
            data.append("google_id", googleId);
            data.append("google_token", googleToken);

            let check = await AccountOperations.LoginByThirdParty(data);
            if (check.data.code === 1) {
                createCookieThatLastsForADay("email", check.data.user?.email);
                createCookieThatLastsForADay(
                    "user_token",
                    check.data?.user_token
                );
                // setIsOpenPopupLoginSignup({ type: null, isOpen: false });
                setPageLoginSignup([]);
                setIsLogin(true);
            }
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <>
            <div className={style.firstScreen}>
                <div className={style.firstScreen_title}>
                    <h1>Bạn muốn tạo tài khoản bằng cách nào nhỉ?</h1>
                </div>
                <div className={style.firstScreen_img}>
                    <MochiImage_modal />
                </div>
                <div className={style.firstScreen_options}>
                    {/* <ButtonMethod
                        isFacebook={true}
                        Icon={() => (
                            <img className="mx-2" width={17} src={facebook} alt="facebook" />
                        )}
						buttonText={'Tạo tài khoản với Facebook'}
                    /> */}
                    <ButtonMethod
                        onClick={handleLoginGoogle}
                        isGoogle={true}
                        Icon={() => (
                            <img
                                className="mx-2"
                                width={30}
                                src={google}
                                alt="google"
                            />
                        )}
                        buttonText={"Tạo tài khoản với G+"}
                    />
                    <p className={style.firstScreen_or}>HOẶC</p>
                    <ButtonCircle
                        onClick={() => {
                            setPageLoginSignup((prev) => ["signup", ...prev]);
                            // setIsOpenPopupLoginSignup({
                            //     isOpen: true,
                            //     type: "signup",
                            // });
                        }}
                        buttonText={"Tự tạo tài khoản với email"}
                        color={"black"}
                        fontSize={"18px"}
                        white={true}
                    />
                </div>
            </div>
        </>
    );
};

export default PopupLoginSignup;
